import api from '@pray/shared/utils/api';

/**
 * Get giving subscription metrics for an artist.
 *
 * For the Pray.com artist (artist._id === 1), returns platform-wide data
 * across all artists.
 *
 * @param {Object} params
 * @param {string} params.artistId - The artist UUID
 * @param {string} [params.startDate] - Start date ISO string
 * @param {string} [params.endDate] - End date ISO string
 * @param {string} [params.interval] - Interval: 'day', 'week', 'month', 'all'
 * @returns {Promise<Object>} Giving metrics
 */
export async function getGivingMetrics({ artistId, startDate, endDate, interval = 'all' }) {
  const params = new URLSearchParams();

  if (startDate) params.append('start_date', startDate);
  if (endDate) params.append('end_date', endDate);
  if (interval) params.append('interval', interval);

  const queryString = params.toString();
  const url = `/web/studio/artists/${artistId}/givingPayments/metrics${queryString ? `?${queryString}` : ''}`;

  const response = await api.get(url);
  return response.data;
}
